import {InvoicingDetailResponse } from '@/types/service-response'

export class InvoicingDetail {
  private constructor (
    readonly projectId: number,
    readonly addressNumber: string,
    readonly addressName: string,
    readonly status: string,
    readonly name: string
  ) {}

  public static createListFromResponse (data: InvoicingDetailResponse[]): InvoicingDetail[] {
    return data.map((item: InvoicingDetailResponse) => {
      return new InvoicingDetail(
        item.ProjektID,
        item.AdressNummer,
        item.AdressName,
        item.Status,
        `${item.AdressNummer} ${item.AdressName}`
      )
    })
  }
}
